import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-search\">\r\n  <path d=\"M9.211,18.29a9.145,9.145,0,1,1,9.211-9.145A9.189,9.189,0,0,1,9.211,18.29Zm0-15.167a6.022,6.022,0,1,0,6.066,6.022A6.051,6.051,0,0,0,9.211,3.123Zm9.33,12.443a11.411,11.411,0,0,1-3.068,2.981L20.964,24,24,20.987l-5.459-5.421Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol